import { createI18n } from 'vue-i18n';
import ptBR from '../locales/pt-BR.json';
import es from '../locales/es.json';
import en from '../locales/en.json';

// Função para obter o idioma do localStorage ou usar o padrão
function getDefaultLocale() {
  const savedLocale = localStorage.getItem('app-locale');
  if (savedLocale) {
    return savedLocale;
  }

  // Detecta o idioma do navegador
  const browserLang = navigator.language || navigator.userLanguage;

  if (browserLang.startsWith('pt')) {
    return 'pt-BR';
  } else if (browserLang.startsWith('es')) {
    return 'es';
  } else if (browserLang.startsWith('en')) {
    return 'en';
  }

  return 'pt-BR'; // Idioma padrão
}

const i18n = createI18n({
  legacy: false, // Para usar a Composition API
  locale: getDefaultLocale(),
  fallbackLocale: 'pt-BR',
  messages: {
    'pt-BR': ptBR,
    'es': es,
    'en': en
  }
});

export default i18n;
